

























































































































// vendor
import { defineComponent, ref, computed, watch } from "@vue/composition-api";
// project
import * as AssetAPI from "@/services/api/assets";
import { Asset, AssetVersion } from "@/psychlab/types";
import { FindAsset } from "@/components.assets/find-asset";
// local
import { default as SelectLang } from "./select-lang.vue";
import { StudyWizardConfig, StudyWizardHandler, Language } from "./ICreateStudyWizard";
import { TipIcon, Rule, Icon, Heading } from "@ui";
import { useTranslate } from "@lang";

export default defineComponent({

	components:{
		FindAsset,
		SelectLang,
		TipIcon,
		Rule,
		Icon,
		Heading,
	},
	setup(_, context){

		const show = ref(false);
		const blueprintId = ref<string|null>(null);
		const version = ref<string|null>(null);
		const name = ref<string|null>(null);
		const description = ref<string|null>(null);
		const blueprint = ref<Asset|null>(null);
		const versions = ref<AssetVersion<any>[]>([]);
		const modal = ref<any>();
		const versionModal = ref<any>(null);
		const selectedBlueprint = ref<any>(null);
		const language = ref<Language>("en");
		const openStudy = ref(true);
		const nameInput = ref<HTMLInputElement>();
		const onDone = ref<StudyWizardHandler|null>(null);

		const { translate } = useTranslate();

		const tag = ref<string|null>(null);

		const activeTag = computed(() => {
			if(context.root.$route.name === "view-tag"){
				return context.root.$route.params["tagId"];
			}
			if(context.root.$route.query["t"]){
				return context.root.$route.query["t"] as string;
			}
			if(context.root.$route.query["tag"]){
				return context.root.$route.query["tag"] as string;
			}
			return null;
		});

		const blueprintName = computed(() => blueprint.value ? blueprint.value.name : "");

		const isLatestSelected = computed(() => {
			if(versions.value.length === 0){ return false; }
			return versions.value.findIndex(v => v._id === version.value) === 0;
		});

		const canSubmit = computed(() => {
			return name.value && name.value.length > 1 && selectedBlueprint.value;
		});

		const getDefaultName = () => {
			return translate("studies.label.newStudy");
		};

		const focusName = (delay:number = 50) => {
			const ni = nameInput.value;
			if(!ni){ return; }
			if(delay === 0){
				ni.select();
			}
			else {
				setTimeout(() => ni.select(), delay);
			}
		};

		const refresh = async() => {
			blueprint.value = blueprintId.value ? await AssetAPI.getAsset(blueprintId.value) : null;
			versions.value = blueprintId.value ? await AssetAPI.loadVersionList(blueprintId.value) : [];
		};

		const hide = () => {
			show.value = false;
			blueprintId.value = null;
			version.value = null;
			name.value = null;
			description.value= null;
			onDone.value = null;
			versions.value = [];
			language.value = "en";
			openStudy.value = true;
			selectedBlueprint.value = null;
			tag.value = null;
		};

		const cancel = () => {
			if(!modal.value){ return; }
			modal.value.hide();
		};

		const submit = () => {
			
			if(selectedBlueprint.value && onDone.value){
				const { asset, version } = selectedBlueprint.value.ref;

				const result = {
					study:asset,
					version,
					name: (!name.value || name.value.length < 2) ? getDefaultName() : name.value,
					description: description.value || "",
					language:language.value,
					openDashboard:openStudy.value,
				};
				onDone.value(result);
			}
			if(modal.value){
				modal.value.hide();
			}
		};

		const open = async(config:StudyWizardConfig, fn:StudyWizardHandler) => {
			const {
				blueprint,
			} = config;

			blueprintId.value = blueprint || null;
			await refresh();
			name.value = getDefaultName();
			show.value = true;

			if(versions.value.length > 0){
				version.value = versions.value[0]._id;
				selectedBlueprint.value = {
					ref:{
						asset:blueprintId.value,
						version:version.value
					}
				};
			}
			onDone.value = fn;
		};

		const changeVersion = async() => {
			if(!blueprintId.value){ return; }
			const versions = await AssetAPI.loadVersionList(blueprintId.value);
			const config = {
				versions,
				value:version.value
			};
			versionModal.value.open(config, (newVersion:string) => {
				version.value = newVersion;
			});
		};

		const onShown = () => {
			focusName(0);
		};

		watch(blueprintId, refresh);

		return {
			openStudy,
			language,
			show,
			blueprintId,
			version,
			name,
			description,
			blueprint,
			versions,
			blueprintName,
			isLatestSelected,
			modal,
			versionModal,
			hide,
			submit,
			open,
			cancel,
			changeVersion,
			selectedBlueprint,
			nameInput,
			onShown,
			canSubmit,
			activeTag,
			translate,
		};
	}
});
